import { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from 'components/atoms/Icon';
import { useNetworkStatus } from 'hooks/useNetworkStatus';
import SystemBanner from './SystemBanner';

export function ConnectionQualityProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { t } = useTranslation();
  const { isPoorConnection, online } = useNetworkStatus();

  const [isBannerVisible, setIsBannerVisible] = useState(true);

  const isOffline = !online;

  const handleDismissPoorConnection = () => {
    setIsBannerVisible(false);
  };


  if (isOffline) return (
    <>
      <SystemBanner
        icon={<Icon icon="signal_wifi_off" />}
        color="error"
        visible={true}
        dismissable={false}
        content={<><b>{t('aiInterview.connectionLost')}</b>. {t('aiInterview.pleaseReconnect')}</>}
      />
      {children}
    </>

  )

  if (isPoorConnection) return (
    <>
      <SystemBanner
        icon={<Icon icon="signal_cellular" />}
        color="warning"
        visible={isBannerVisible}
        dismissable
        content={
          <>
            <b>{t('aiInterview.unstableConnection')}</b>
            {t('aiInterview.unstableConnectionDescription')}
          </>
        }
        onDismiss={handleDismissPoorConnection}
      />
      {children}
    </>
  )


  return children;
}
